import { ListWrapper } from './style';

export type ListProps = {
  children: React.ReactNode;
};

export const List = ({ children }: ListProps) => {
  return <ListWrapper>{children}</ListWrapper>;
};
